import axios from "axios";

export const API = axios.create({
  baseURL: "https://637340840bb6b698b60661aa.mockapi.io",
});

